import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Loader } from '../../../../../components';
import { IColorOptionUris } from '../../../../../models';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface IExcludedColorOptions {
  colorUris: IColorOptionUris;
  isLoadingColorExclusionOptions: boolean;
}

export const ExcludedColorOptions: FC<IExcludedColorOptions> = ({
  colorUris,
  isLoadingColorExclusionOptions
}) => {
  const classes = useStyles();
  const isMobile = useMediaQuery(`(max-width: 600px)`);

  const ColorOptions = ({ options, name }) => {
    if (Array.isArray(options)) {
      return (
        <>
          <Grid
            item
            sx={{
              marginTop: '1rem',
              alignSelf: isMobile ? 'flex-start' : 'flex-end'
            }}
          >
            <Typography variant="caption" sx={{ display: 'block' }} className={classes.bold}>
              {name}
            </Typography>
            <div>
              <picture>
                {options.map((uri, index) => {
                  return (
                    <img
                      key={`${index}`}
                      style={{
                        width: 50,
                        height: 20
                      }}
                      src={uri}
                      alt={`${name + index}`}
                    />
                  );
                })}
              </picture>
            </div>
          </Grid>
        </>
      );
    } else {
      return (
        <>
          <Grid
            item
            sx={{
              marginTop: '1rem',
              alignSelf: isMobile ? 'flex-start' : 'flex-end',
              paddingRight: name === 'Window' ? '1rem' : ''
            }}
          >
            <Typography variant="caption" sx={{ display: 'block' }} className={classes.bold}>
              {name}
            </Typography>
            <div>
              <picture>
                <img className={classes.colorImage} src={options} alt={name} />
              </picture>
            </div>
          </Grid>
        </>
      );
    }
  };

  return (
    <>
      {isLoadingColorExclusionOptions && (
        <Box mt={1} minHeight="5rem" display="flex" flexDirection="column" justifyContent="center">
          <Loader type="inline" position="centered">
            Loading...
          </Loader>
        </Box>
      )}
      {!isLoadingColorExclusionOptions && (
        <Box mt={0.5} mb={0.5}>
          <Grid
            item
            container
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 0 : 1}
            alignItems={isMobile ? 'start' : 'center'}
            wrap="nowrap"
          >
            {colorUris?.brickMortarColorUri !== null && (
              <ColorOptions name={'Brick'} options={colorUris?.brickMortarColorUri} />
            )}
            <ColorOptions name={'Roof'} options={colorUris?.roofColorUri} />
            <ColorOptions name={'Trim'} options={colorUris?.trimColorUri} />
            <ColorOptions name={'Paint'} options={colorUris?.paintColorUris} />
            <ColorOptions name={'Shutter'} options={colorUris?.shutterPaintColorUris} />
            <ColorOptions name={'Window'} options={colorUris?.windowColorUri} />
            {colorUris?.garageDoorColorUri !== null && (
              <ColorOptions name={'Garage Door'} options={colorUris?.garageDoorColorUri} />
            )}
          </Grid>
        </Box>
      )}
    </>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  bold: {
    fontWeight: 600
  },
  picture: {
    userSelect: 'none',
    cursor: 'pointer',
    '&:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: theme.palette.common.white,
      fontSize: '0.85rem',
      position: 'absolute',
      textAlign: 'center',
      height: 50,
      width: 50,
      padding: 4
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& :not(:last-child)': {
      marginRight: theme.spacing(0.33)
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    '& :not(:last-child)': {
      marginBottom: theme.spacing(0.33)
    }
  },
  colorImage: {
    width: 50,
    height: 50
  }
}));
